import type { Modul } from "./modul";
import { Mitteilungen } from "./seiten/Mitteilungen";
import { Profil } from "./seiten/Profil";
import { PushSchluessel } from "./seiten/PushSchluessel";
import { Start } from "./seiten/Start";

/** Seiten des Kerns: Startseite, Mitteilungen, Profil. Das Aufgaben-Modul ersetzt die Startseite durch „Meine Woche“.
 *  Mitteilungen und Profil stehen nicht in der Seitenleiste, sondern in der Kopfzeile (KOPFZEILE.md). Der Eintrag Mitteilungen
 *  bleibt für die untere Leiste am Handy. */
export const kern: Modul = {
  id: "kern",
  name: "Kern",
  routen: [
    { pfad: "/", seite: Start },
    { pfad: "/mitteilungen", seite: Mitteilungen },
    { pfad: "/profil", seite: Profil },
    { pfad: "/push-schluessel", seite: PushSchluessel, recht: "zugaenge.verwalten" },
  ],
  navigation: [
    { bereich: "start", label: "Meine Woche", pfad: "/", icon: "woche", leiste: 1, leisteLabel: "Woche", reihenfolge: 0 },
    { bereich: "unten", label: "Mitteilungen", pfad: "/mitteilungen", icon: "glocke", leiste: 4 },
  ],
  ereignisse: [],
};
